import classnames from 'classnames/bind';

import { DataWidgetFiltersInput } from 'dashboards/types/filter';

import { IconButton } from 'components/IconButton/IconButtonDeprecated';

import { ColumnInput } from './ColumnInput';
import { OperatorInput } from './OperatorInput';
import { SuggestionInput } from './SuggestionInput/SuggestionInput';
import { useDataWidgetFiltersInputState } from './context';
import styles from './DataWidgetFiltersInput.module.scss';

const c = classnames.bind(styles);

export function DataWidgetFilter(filter: DataWidgetFiltersInput) {
  const { removeFilter } = useDataWidgetFiltersInputState();

  const { id, column, operator } = filter;

  function handleCancelClick() {
    removeFilter(id);
  }

  return (
    <div className={c('group-item')}>
      <div className={c('filter')}>
        <ColumnInput id={id} column={column} />
        <OperatorInput id={id} column={column} operator={operator} />
        <SuggestionInput {...filter} />

        <IconButton
          icon="cancel"
          label="Remove filter"
          onClick={handleCancelClick}
        />
      </div>
    </div>
  );
}
